import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import './InternalReportsConfiguration.css';
import MonthlyConfiguration from './Internal-Reports/MonthlyConfiguration';
import FactoryDataExtractor from './Internal-Reports/FactoryDataExtractor';
import FactoryDataUpload from './Internal-Reports/FactoryDataUpload';

function InternalReportsConfiguration() {
    const [selectedTab, setSelectedTab] = useState(0);
    const backgroundGradient = 'linear-gradient(to right, #F0F4F7, #FFFFFF)';

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', background: backgroundGradient }}>
            {/* Left-side Navigation Panel */}
            <Box sx={{ width: '250px', background: '#E3E6EA', padding: 2, borderRight: '2px solid #ccc' }}>
                <h3>Configuration</h3>
                <Tabs
                    orientation="vertical"
                    value={selectedTab}
                    onChange={(event, newValue) => setSelectedTab(newValue)}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label="Monthly Budget & Stock" />
                    <Tab label="Factory Data Configuration" />
                    <Tab label="Factory Data Upload" />
                </Tabs>
            </Box>

            {/* Main Content Area */}
            <Box sx={{ flexGrow: 1, padding: 3 }}>
                <h2>Internal Reports Configuration</h2>
                {selectedTab === 0 && <MonthlyConfiguration />}
                {selectedTab === 1 && <FactoryDataExtractor />}
                {selectedTab === 2 && <FactoryDataUpload />}
            </Box>
        </Box>
    );
}

export default InternalReportsConfiguration;
